import { Component, ViewEncapsulation, ViewChild, ChangeDetectorRef, OnChanges, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SelectEvent, TabStripComponent, TabStripTabComponent } from '@progress/kendo-angular-layout';
import { GlobalsService } from '../../shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { v_InventoryBus } from '../../shared/models/v_InventoryBus';
import { InventoryBus } from '../../shared/models/InventoryBus';
import { InventoryReference } from '../../shared/models/InventoryReference';
import { GItem } from '../../shared/models/GItem';
import * as _ from 'lodash';
import { BaseDQOIComponent } from '../../shared/base-components/base-dqoi.component';
import { DQOIReferenceData } from '../../shared/models/DQOIReferenceData';
import { BaseAppMComponent } from '../../shared/base-components/base-app-m.component';
import { CommonFunctions } from '../../shared/static/common-functions';
import { InventoryLocationXrefBus } from '../../shared/models/InventoryLocationXrefBus';
import { InventoryThresholdOverrideBus } from '../../shared/models/InventoryThresholdOverrideBus';
import { InventorySupplierXrefBus } from '../../shared/models/InventorySupplierXrefBus';
import { InventoryBusInputParams } from '../../shared/models/InventoryBusInputParams';
import { PartThresholdsComponent } from './thresholds/part-thresholds.component';
import { PartSuppliersComponent } from './suppliers/part-suppliers.component';
import { PartInventoryComponent } from './inventory/part-inventory.component';
import { DomSanitizer } from '@angular/platform-browser';
import { FileRestrictions, FileInfo, RemoveEvent, SelectEvent as FileSelectEvent } from '@progress/kendo-angular-upload';
import { InventoryPhotoBus } from '../../shared/models/InventoryPhotoBus';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { CmProAuthService } from '../../../core/services';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { CRUDActions } from '../../shared/enums/CRUDActions';
import { InventoryConsumablesBus } from '../../shared/models/InventoryConsumablesBus';
import { InventoryConsMatchesBus } from '../../shared/models/InventoryConsMatchesBus';
import { InventoryConsumablesComponent } from '../inventory-consumables/inventory-consumables.component';
import { InventoryConsMatchesComponent } from '../inventory-cons-matches/inventory-cons-matches.component';
import { PartBranchThresholdsComponent } from './branch-threshold/part-branch-thresholds.component';
import { PartAlternativesThresholdsComponent } from './alternatives-threshold/part-alternatives-thresholds.component';
import { InventoryThresholdOverrideBranchBus } from '../../shared/models/InventoryThresholdOverrideBranchBus';
import { Message } from '../../shared/models/message';
import { MessageType } from '../../shared/enums/MessageType';
import { InventoryPartNbrsBus } from '../../shared/models/InventoryPartNbrsBus';
import { PartNbrsComponent } from './part-nbrs/part-nbrs.component';
import { Align } from "@progress/kendo-angular-popup";
import { CommonValues } from '../../shared/static/CommonValues';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { InventoryThresholdOverrideAlternative } from '../../shared/models/InventoryThresholdOverrideAlternative';
import { UsersBus } from '@app/cp/shared/models/UsersBus.model';
import { ActivatedRoute, Params, Router } from "@angular/router";
import { nameOf } from '@app/shared/utils/helper';

@Component({
    selector: 'parts',
    templateUrl: './parts.component.html',
    styleUrls: ['./parts.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PartsComponent extends BaseAppMComponent<InventoryBus, InventoryService, null, null> implements OnChanges, OnInit, OnDestroy {
    myFiles1: Array<FileInfo> = [];
    public imagePreviews: any[] = [];
    partPhoto: any;
    inventorySearch: boolean = false;
    inventorySearching: boolean = false;
    inventorySearchMerge: boolean = false;
    subs_data_search: Subscription;
    appCode: string = "Parts";
    inventoryReferenceData: InventoryReference = new InventoryReference();
    subs_data_ref: Subscription;
    readOnly: boolean = false;
    id: string = null;
    inventoryTypes: GItem[] = null;
    selected_inventoryTypes: GItem;
    inventoryCategories: GItem[] = null;
    selected_inventoryCategories: GItem;
    inventorySubCategories: GItem[] = null;
    selected_inventorySubCategories: GItem;
    manufacturerTypes: GItem[] = null;
    selected_manufacturerTypes: GItem;
    manufacturers: GItem[] = null;
    branches: GItem[] = null;
    warehouses: GItem[] = null;
    selected_manufacturers: GItem;
    accounts: GItem[] = null;
    selected_accounts: GItem;
    loadingThings: boolean = false;
    searchActive: boolean = true;
    addPhoto: boolean = false;
    public partPhotoForm: UntypedFormGroup;
    files: Array<FileInfo> = [];
    activeIndex: number = 0;
    activeIndexDialog: number = 0;
    deleteId: string = "";
    idsToBeCleared: string[] = [];
    public popUp: boolean = false;
    info: boolean = false;
    public anchorAlign: Align = { horizontal: "right", vertical: "bottom" };
    public popupAlign: Align = { horizontal: "right", vertical: "top" };
    commonValues = CommonValues;
    queryParams: Params = [];
    onscrollviewItemChange(event) {
        if (event) {

            this.activeIndexDialog = event.index;
            console.log('onitemchage', event);
        }

    }
    public hasPhotos: boolean = false;
    public hasMergePhotos: boolean = false;

    @ViewChild("partThresholds") partThresholds: PartThresholdsComponent;
    @ViewChild("partBranchThresholds") partBranchThresholds: PartBranchThresholdsComponent;
    @ViewChild("partAlternativesThresholds") partAlternativesThresholds: PartAlternativesThresholdsComponent;

    @ViewChild("partSuppliers") partSuppliers: PartSuppliersComponent;
    @ViewChild("partInventory") partInventory: PartInventoryComponent;
    @ViewChild('partsTabstrip') public partsTabstrip: TabStripComponent;

    @ViewChild("inventoryConsumables") inventoryConsumables: InventoryConsumablesComponent;
    @ViewChild("inventoryConsMatches") inventoryConsMatches: InventoryConsMatchesComponent;
    @ViewChild("inventoryPartNbrs") inventoryPartNbrs: PartNbrsComponent;
    searchValue: string = "";
    searchMergeValue: string = "";
    get DQOIreferenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    data: InventoryBus;
    dataMerge: InventoryBus;
    constructor(globals: GlobalsService,
        featureFlagService: FeatureFlagService,
        private _qry_rd: DQOIReferenceDataQuery,
        svc_data: InventoryService,
        private cd: ChangeDetectorRef,
        private sanitizer: DomSanitizer,
        private authService: CmProAuthService,
        private activatedRoute: ActivatedRoute,
        private router: Router) {
        super(globals, featureFlagService, _qry_rd);
        this.svc_data = svc_data;
        this.createForm();
        this.createPhotoForm();
    }
    public editForm: UntypedFormGroup;
    canEditAccounts: boolean;
    private subs_featureFlagSet: Subscription; //place as class variable
    featureFlagSet = {};
    override ngOnInit() {
        super.ngOnInit();
        this.subs_data_ref = this.svc_data.getReferenceData().subscribe(data => {
            this.inventoryReferenceData = new InventoryReference(data);
            if (CommonFunctions.hasArrayValue(this.data.inventoryThresholdOverrides)) {
                for (let i = 0; i < this.data.inventoryThresholdOverrides.length; i++) {
                    this.data.inventoryThresholdOverrides[i].supplier = this.inventoryReferenceData.getSupplier(this.data.inventoryThresholdOverrides[i].supplierId);
                }
            }
            if (CommonFunctions.hasArrayValue(this.data.inventoryThresholdOverrideBranchs)) {
                for (let i = 0; i < this.data.inventoryThresholdOverrideBranchs.length; i++) {
                    this.data.inventoryThresholdOverrideBranchs[i].supplier = this.inventoryReferenceData.getSupplier(this.data.inventoryThresholdOverrideBranchs[i].supplierId);
                }
            }
        });
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.rights = user.appClaims;
                this.readOnly = !user.appClaims.MaintainParts;
                this.canEditAccounts = this.determineCanEditAccounts();
            }
        });
        this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe((data: any) => {
            this.featureFlagSet = data;
            this.setAnyLoadingsOn();
        });

        if (this.featureFlagSet["ui-allow-direct-linking-parts"]) {
            this.activatedRoute.params.subscribe(params => {
                this.queryParams = params;
                if (this.queryParams && this.queryParams['InventoryId']) {
                    if (this.queryParams['InventoryId']?.length === 36) {
                        this.inventorySelected(this.queryParams);
                    } else {
                        this.globals.notifyError("Part not found or ID is incorrect. Use search to try again", true);
                    }
                }
            });
        }
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_data_ref);
        CommonFunctions.unsubscribe(this.subs_featureFlagSet); //place in ngOnDestroy
        this.authService.unsubscribeToLoginEvents();
    }

    setFormAddtl() {
        this.editForm.patchValue({

        });
        if (CommonFunctions.hasValue(this.partThresholds)) {
            this.partThresholds.clearDeleted();
        }
        if (CommonFunctions.hasValue(this.partBranchThresholds)) {
            this.partBranchThresholds.clearDeleted();
        }

        if (CommonFunctions.hasValue(this.partSuppliers)) {
            this.partSuppliers.clearDeleted();
        }

        if (CommonFunctions.hasValue(this.partInventory)) {
            this.partInventory.clearDeleted();
        }
        if (CommonFunctions.hasValue(this.inventoryConsumables)) {
            this.inventoryConsumables.clearDeleted();
        }
        if (CommonFunctions.hasValue(this.inventoryConsMatches)) {
            this.inventoryConsMatches.clearDeleted();
        }
        if (CommonFunctions.hasValue(this.inventoryPartNbrs)) {
            this.inventoryPartNbrs.clearDeleted();
        }
        if (CommonFunctions.hasArrayValue(this.data.inventoryPhotos)) {
            this.hasPhotos = true;
        }

        if (this.data.warrantyEndDate) {
            var tempDate = new Date(this.data.warrantyEndDate);
            this.editForm.patchValue({

                warrantyEndDate: tempDate,
            });
        }

    }
    panelExpand(e: any) { }
    onTabSelect(e: SelectEvent, tabstrip: any) {
        this.tabstrip.selectTab(tabstrip);
    }
    setInventorySearchData(value: any) {
        this.svc_data.getViewById(value.InventoryId).subscribe((data: v_InventoryBus) => {

            this.inventorySearching = false;

        });
    }
    photoViewer: boolean = false;
    closePhotoViewer() { this.photoViewer = false; }
    openPhotoViewer() { this.photoViewer = true; }
    getInventoryData(id: string) {
        if (!id) {
            this.globals.notifyError(`Unable to load inventory data. No ID found. ${CommonValues.ErrorMessages_BaseErrorSuffix}`);
            return;
        }
        this.mainDataLoading = true;
        this.svc_data.getOnly(id).subscribe((data: InventoryBus) => {
            this.idsToBeCleared = [];
            this.mainDataLoading = false;
            this.data = new InventoryBus(data);
            this.originalData = _.cloneDeep(this.data);
            this.setForm();
            this.getAdditionalPartsData(id);
        });

    }
    mainDataLoading: boolean = false;
    testLoading() {
        this.mainDataLoading = !this.mainDataLoading;
    }

    getEncodedImageUrl(imageName: string): string {
        if (!imageName) {
            return "";
        }
        const baseUrl = this.svc_data.getPhotoUrl();
        const url = this.svc_data.getPhotoUrl() + encodeURIComponent(imageName);
        return url;
    }
    getAdditionalPartsData(id: string) {
        this.addtlDataLoader = true;
        this.svc_data.getAdditionalPartsData(id).subscribe({
            next: (data: InventoryBus) => {
                this.idsToBeCleared = [];
                this.data.photoURL = this.svc_data.getPhotoUrl();
                let arr = [];
                if (CommonFunctions.hasArrayValue(data.inventoryLocationXrefBuss)) {
                    for (let i = 0; i < data.inventoryLocationXrefBuss.length; i++) {
                        let newObj: InventoryLocationXrefBus = new InventoryLocationXrefBus(data.inventoryLocationXrefBuss[i]);
                        arr.push(newObj);
                    }
                }
                arr.sort((a, b) => (a.warehouse > b.warehouse) ? 1 : -1);
                this.data.inventoryLocationXrefBussAll = arr;
                this.showInactiveChanged(this.partInventory.showInactive || !this.featureFlagSet['warehouse-list-to-only-show-active-warehouses']);


                let arrpn = [];
                if (CommonFunctions.hasArrayValue(data.inventoryPartNbrs)) {
                    for (let i = 0; i < data.inventoryPartNbrs.length; i++) {
                        let newObj: InventoryPartNbrsBus = new InventoryPartNbrsBus(data.inventoryPartNbrs[i]);
                        newObj.manufacturer = this.inventoryReferenceData.getManufacturer(newObj.manufacturerId);
                        arrpn.push(newObj);
                    }
                }
                arrpn.sort((a, b) => (a.partNbr > b.partNbr) ? 1 : -1);
                this.data.inventoryPartNbrs = arrpn;

                let arr1 = [];
                if (CommonFunctions.hasArrayValue(data.inventoryThresholdOverrides)) {
                    for (let i = 0; i < data.inventoryThresholdOverrides.length; i++) {
                        let newObj1: InventoryThresholdOverrideBus = new InventoryThresholdOverrideBus(data.inventoryThresholdOverrides[i]);
                        newObj1.supplier = this.inventoryReferenceData.getSupplier(newObj1.supplierId);
                        arr1.push(newObj1);
                    }
                }
                this.data.inventoryThresholdOverrides = arr1;

                let arr1a = [];
                if (CommonFunctions.hasArrayValue(data.inventoryThresholdOverrideBranchs)) {
                    for (let i = 0; i < data.inventoryThresholdOverrideBranchs.length; i++) {
                        let newObj1a: InventoryThresholdOverrideBranchBus = new InventoryThresholdOverrideBranchBus(data.inventoryThresholdOverrideBranchs[i]);
                        newObj1a.supplier = this.inventoryReferenceData.getSupplier(newObj1a.supplierId);
                        arr1a.push(newObj1a);
                    }
                }
                this.data.inventoryThresholdOverrideBranchs = arr1a;

                let arr1b = [];
                if (CommonFunctions.hasArrayValue(data.inventoryAlternatives)) {
                    for (let i = 0; i < data.inventoryAlternatives.length; i++) {
                        let newObj1b: InventoryThresholdOverrideAlternative = new InventoryThresholdOverrideAlternative(data.inventoryAlternatives[i]);
                        arr1b.push(newObj1b);
                    }
                }
                this.data.inventoryAlternatives = arr1b;

                let arr2 = [];
                if (CommonFunctions.hasArrayValue(data.inventorySupplierXrefBuss)) {
                    for (let i = 0; i < data.inventorySupplierXrefBuss.length; i++) {
                        let newObj2: InventorySupplierXrefBus = new InventorySupplierXrefBus(data.inventorySupplierXrefBuss[i]);
                        newObj2.supplierName = this.inventoryReferenceData.getSupplier(newObj2.supplierId);
                        arr2.push(newObj2);
                    }
                }
                arr2.sort((a, b) => (a.supplierName > b.supplierName) ? 1 : -1);
                this.data.inventorySupplierXrefBuss = arr2;

                let arr3 = [];
                if (CommonFunctions.hasArrayValue(data.inventoryPhotos)) {
                    this.activeIndex = 0;
                    for (let i = 0; i < data.inventoryPhotos.length; i++) {
                        let newObj3: InventoryPhotoBus = new InventoryPhotoBus();
                        newObj3.initialize(data.inventoryPhotos[i]);
                        if (newObj3 && newObj3.fileName) {
                            arr3.push(newObj3);
                        }
                    }
                }
                this.data.inventoryPhotos = arr3.filter(photo => photo && photo.fileName);
                if (CommonFunctions.hasArrayValue(this.data.inventoryPhotos)) {
                    this.hasPhotos = this.data.inventoryPhotos.length > 0;
                }

                let arr4 = [];
                if (CommonFunctions.hasArrayValue(data.inventoryConsumablesBuss)) {
                    this.activeIndex = 0;
                    for (let i = 0; i < data.inventoryConsumablesBuss.length; i++) {
                        let newObj3: InventoryConsumablesBus = new InventoryConsumablesBus(data.inventoryConsumablesBuss[i]);
                        arr4.push(newObj3);
                    }
                }
                this.data.inventoryConsumablesBuss = arr4;

                let arr5 = [];
                if (CommonFunctions.hasArrayValue(data.inventoryConsMatchesBuss)) {
                    this.activeIndex = 0;
                    for (let i = 0; i < data.inventoryConsMatchesBuss.length; i++) {
                        let newObj3: InventoryConsMatchesBus = new InventoryConsMatchesBus(data.inventoryConsMatchesBuss[i]);
                        arr5.push(newObj3);
                    }
                }
                this.data.inventoryConsMatchesBuss = arr5;
                this.warehouses = _.cloneDeep(data.warehouses);
                this.branches = _.cloneDeep(data.branches);
                this.originalData = _.cloneDeep(this.data);
                this.setForm();
                this.setFormAddtl();
                this.addtlDataLoader = false;
            },
            error: (err) => {
                this.addtlDataLoader = false;
                console.error('Error loading additional parts data:', err);
                this.globals.notifyError(`Error loading additional parts data: ${err.message}`, true);
            }
        });

    }
    showInactiveChanged(value: boolean) {
        if (value) { this.data.inventoryLocationXrefBuss = _.cloneDeep(this.data.inventoryLocationXrefBussAll); }
        else {
            let arrActive = this.data.inventoryLocationXrefBussAll.filter(a => a.isActive);
            this.data.inventoryLocationXrefBuss = arrActive;
        }
    }
    itemDisabled(itemArgs: { dataItem: any, index: any; }) {
        return !itemArgs.dataItem.canSelect;
    }
    loadData(id: string) {
        this.loadingThings = true;
        this.hasPhotos = false;
        this.getInventoryData(id);
    }
    stagingWarehouseHasQty = false;
    partsToMove = 0;
    impactValue = 0;
    loadMergeData(id: string) {
        this.hasMergePhotos = false;
        this.stagingWarehouseHasQty = false;
        this.svc_data.get(id).subscribe((data: InventoryBus) => {
            this.dataMerge = new InventoryBus(data);
            this.dataMerge.photoURL = this.svc_data.getPhotoUrl();
            let arr = [];
            this.partsToMove = 0;
            if (CommonFunctions.hasArrayValue(data.inventoryLocationXrefBuss)) {
                for (let i = 0; i < data.inventoryLocationXrefBuss.length; i++) {
                    let newObj: InventoryLocationXrefBus = new InventoryLocationXrefBus(data.inventoryLocationXrefBuss[i]);
                    newObj.warehouse = this.inventoryReferenceData.getInventoryLocation(newObj.inventoryLocationId);
                    arr.push(newObj);
                    if (newObj.inventoryLocationId == CommonValues.InventoryLocation_StagingWarehouse && newObj.quantity != 0) {
                        this.stagingWarehouseHasQty = true;
                    }
                    else {
                        if (newObj.quantity) {
                            this.partsToMove = this.partsToMove + newObj.quantity;
                        }
                    }
                }
            }

            this.impactValue = null;
            if (this.dataMerge.avgCost && this.data.avgCost && this.partsToMove) {
                this.impactValue = (this.data.avgCost - this.dataMerge.avgCost) * this.partsToMove;
            }

            arr.sort((a, b) => (a.warehouse > b.warehouse) ? 1 : -1);

            this.dataMerge.inventoryLocationXrefBuss = arr;
            let arrpn = [];
            if (CommonFunctions.hasArrayValue(data.inventoryPartNbrs)) {
                for (let i = 0; i < data.inventoryPartNbrs.length; i++) {
                    let newObj: InventoryPartNbrsBus = new InventoryPartNbrsBus(data.inventoryPartNbrs[i]);
                    newObj.manufacturer = this.inventoryReferenceData.getManufacturer(newObj.manufacturerId);
                    arrpn.push(newObj);
                }
            }

            arrpn.sort((a, b) => (a.partNbr > b.partNbr) ? 1 : -1);

            this.dataMerge.inventoryPartNbrs = arrpn;

            let arr1 = [];
            if (CommonFunctions.hasArrayValue(data.inventoryThresholdOverrides)) {
                for (let i = 0; i < data.inventoryThresholdOverrides.length; i++) {
                    let newObj1: InventoryThresholdOverrideBus = new InventoryThresholdOverrideBus(data.inventoryThresholdOverrides[i]);
                    arr1.push(newObj1);
                }
            }
            this.dataMerge.inventoryThresholdOverrides = arr1;

            let arr1a = [];
            if (CommonFunctions.hasArrayValue(data.inventoryThresholdOverrideBranchs)) {
                for (let i = 0; i < data.inventoryThresholdOverrideBranchs.length; i++) {
                    let newObj1a: InventoryThresholdOverrideBranchBus = new InventoryThresholdOverrideBranchBus(data.inventoryThresholdOverrideBranchs[i]);
                    arr1a.push(newObj1a);
                }
            }
            this.dataMerge.inventoryThresholdOverrideBranchs = arr1a;

            let arr2 = [];
            if (CommonFunctions.hasArrayValue(data.inventorySupplierXrefBuss)) {
                for (let i = 0; i < data.inventorySupplierXrefBuss.length; i++) {
                    let newObj2: InventorySupplierXrefBus = new InventorySupplierXrefBus(data.inventorySupplierXrefBuss[i]);
                    newObj2.supplierName = this.inventoryReferenceData.getSupplier(newObj2.supplierId);
                    arr2.push(newObj2);
                }
            }
            arr2.sort((a, b) => (a.supplierName > b.supplierName) ? 1 : -1);
            this.dataMerge.inventorySupplierXrefBuss = arr2;

            let arr3 = [];
            if (CommonFunctions.hasArrayValue(data.inventoryPhotos)) {
                this.activeIndex = 0;
                for (let i = 0; i < data.inventoryPhotos.length; i++) {
                    let newObj3: InventoryPhotoBus = new InventoryPhotoBus();
                    newObj3.initialize(data.inventoryPhotos[i]);
                    arr3.push(newObj3);
                }
            }
            this.dataMerge.inventoryPhotos = arr3;
            if (CommonFunctions.hasArrayValue(this.data.inventoryPhotos)) {
                this.hasMergePhotos = true;
            }

            let arr4 = [];
            if (CommonFunctions.hasArrayValue(data.inventoryConsumablesBuss)) {
                this.activeIndex = 0;
                for (let i = 0; i < data.inventoryConsumablesBuss.length; i++) {
                    let newObj3: InventoryConsumablesBus = new InventoryConsumablesBus(data.inventoryConsumablesBuss[i]);
                    arr4.push(newObj3);
                }
            }
            this.dataMerge.inventoryConsumablesBuss = arr4;

            let arr5 = [];
            if (CommonFunctions.hasArrayValue(data.inventoryConsMatchesBuss)) {
                this.activeIndex = 0;
                for (let i = 0; i < data.inventoryConsMatchesBuss.length; i++) {
                    let newObj3: InventoryConsMatchesBus = new InventoryConsMatchesBus(data.inventoryConsMatchesBuss[i]);
                    arr5.push(newObj3);
                }
            }
            this.dataMerge.inventoryConsMatchesBuss = arr5;
        });
    }

    doMerge() {
        if (!this.data.inventoryLocationXrefBuss) {
            this.data.inventoryLocationXrefBuss = [];
        }
        this.editForm.patchValue({
            currentCost: this.dataMerge.currentCost,
            maxCost: this.dataMerge.maxCost,
        });
        this.editForm.markAsDirty();
        if (CommonFunctions.hasArrayValue(this.dataMerge.inventoryLocationXrefBuss)) {
            for (let i = 0; i < this.dataMerge.inventoryLocationXrefBuss.length; i++) {
                if (this.dataMerge.inventoryLocationXrefBuss[i].inventoryLocationId != CommonValues.InventoryLocation_StagingWarehouse) {
                    let newObj: InventoryLocationXrefBus = new InventoryLocationXrefBus(this.dataMerge.inventoryLocationXrefBuss[i]);
                    if (newObj.quantity != 0) {
                        const index = this.data.inventoryLocationXrefBuss.findIndex(item => item.inventoryLocationId === newObj.inventoryLocationId);
                        if (index >= 0) {
                            const dataItem = this.data.inventoryLocationXrefBuss[index];
                            if (!dataItem.isAdded) {
                                dataItem.isUpdated = true;
                            }
                            dataItem.oldQuantity = dataItem.quantity;
                            dataItem.quantity = dataItem.quantity + newObj.quantity;
                            dataItem.isMerged = true;
                            dataItem.mergeQuantityChange = dataItem.quantity - this.data.inventoryLocationXrefBuss[index].oldQuantity;
                            dataItem.mergeDescription = 'Quantity changed from ' + dataItem.oldQuantity + ' to ' + dataItem.quantity + ' increase of ' + dataItem.mergeQuantityChange;
                        }
                        else {
                            newObj.inventoryId = this.data.inventoryId;
                            newObj.inventoryLocationXrefid = CommonFunctions.getGuid();
                            newObj.isAdded = true;
                            newObj.isMerged = true;
                            newObj.mergeQuantityChange = newObj.quantity;
                            newObj.mergeDescription = 'Quantity changed from 0 to ' + newObj.quantity + ' increase of ' + newObj.mergeQuantityChange;
                            this.data.pushWithChangeDetection(nameOf<InventoryBus>().inventoryLocationXrefBuss, newObj);
                        }
                    }
                }
            }
        }
        if (!this.data.inventorySupplierXrefBuss) {
            this.data.inventorySupplierXrefBuss = [];
        }
        if (CommonFunctions.hasArrayValue(this.dataMerge.inventorySupplierXrefBuss)) {
            for (let i = 0; i < this.dataMerge.inventorySupplierXrefBuss.length; i++) {
                let newObj: InventorySupplierXrefBus = new InventorySupplierXrefBus(this.dataMerge.inventorySupplierXrefBuss[i]);

                newObj.inventoryId = this.data.inventoryId;
                newObj.inventorySupplierXrefid = CommonFunctions.getGuid();
                newObj.isAdded = true;
                newObj.isMerged = true;
                var foundSupplier = this.data.inventorySupplierXrefBuss.find(a => a.supplierId == newObj.supplierId);
                if (!foundSupplier) {
                    this.data.pushWithChangeDetection(nameOf<InventoryBus>().inventorySupplierXrefBuss, newObj);
                }
            }
        }
        if (!this.data.inventoryPartNbrs) {
            this.data.inventoryPartNbrs = [];
        }
        if (CommonFunctions.hasArrayValue(this.dataMerge.inventoryPartNbrs)) {
            for (let i = 0; i < this.dataMerge.inventoryPartNbrs.length; i++) {
                let newObj: InventoryPartNbrsBus = new InventoryPartNbrsBus(this.dataMerge.inventoryPartNbrs[i]);

                newObj.inventoryId = this.data.inventoryId;
                newObj.inventoryPartNbrId = CommonFunctions.getGuid();
                newObj.isAdded = true;
                newObj.isMerged = true;
                this.data.pushWithChangeDetection(nameOf<InventoryBus>().inventoryPartNbrs, newObj);
            }
        }
        this.idsToBeCleared.push(this.dataMerge.inventoryId);
        this.mergingPart = false;
        this.dataMerge = null;
    }

    searchValueChanged(value: any) {

        this.searchValue = value;
    }
    searchMergeValueChanged(value: any) {

        this.searchMergeValue = value;
    }
    inventorySelected(value: any) {
        this.inventorySearch = false;
        if (value != null) {
            this.loadData(value.InventoryId);
            if (this.featureFlagService.latestFeatureFlagSet["ui-allow-direct-linking-parts"]) {
                this.router.navigate(
                    ['/orderinginventory/Parts/', value.InventoryId]
                );
            }
        }
        else {
            this.inventorySearching = false;
        }

    }

    inventoryMergeSelected(value: any) {

        this.inventorySearchMerge = false;
        if (value != null) {
            this.loadMergeData(value.InventoryId);
        }
        else {
            this.inventorySearchMerge = false;
        }

    }
    createPhotoForm() {
        this.partPhotoForm = new UntypedFormGroup({
            'imageName': new UntypedFormControl('', Validators.required),
            'description': new UntypedFormControl(''),
            'visibleToCustomers': new UntypedFormControl(),
            'sequenceNumber': new UntypedFormControl(),
            'inventoryPhotoCategoryId': new UntypedFormControl('', Validators.required),
        });

    }

    createForm() {
        this.editForm = new UntypedFormGroup({
            'inventoryId': new UntypedFormControl(),
            'number': new UntypedFormControl(''),
            'warrantyEndDate': new UntypedFormControl(),
            'serialNbr': new UntypedFormControl(),
            'model': new UntypedFormControl(),
            'manufacturerNumber': new UntypedFormControl(),
            'fullDescription': new UntypedFormControl('', Validators.required),
            'inventoryDesc': new UntypedFormControl('', Validators.required),
            'nonPart': new UntypedFormControl(),
            'isCommon': new UntypedFormControl(),
            'isActive': new UntypedFormControl(),
            'inventoryTypeId': new UntypedFormControl('', Validators.required),
            'inventoryCategoryId': new UntypedFormControl('', Validators.required),
            'inventorySubCategoryId': new UntypedFormControl(),
            'manufacturerId': new UntypedFormControl(),
            'manufacturerTypeId': new UntypedFormControl(),
            'incomeAccountId': new UntypedFormControl('', Validators.required),
            'inventoryAccountId': new UntypedFormControl('', Validators.required),
            'costAccountId': new UntypedFormControl('', Validators.required),
            'notes': new UntypedFormControl(),
            'minThreshold': new UntypedFormControl(),
            'maxThreshold': new UntypedFormControl(),
            'currentCost': new UntypedFormControl(),
            'maxCost': new UntypedFormControl(),
            'avgCost': new UntypedFormControl(),
            'lastCost': new UntypedFormControl(),
            'flatCost': new UntypedFormControl(),
            'internationalCost': new UntypedFormControl(),
            'defaultPrice': new UntypedFormControl(),
            'ratio': new UntypedFormControl(),
            'wgtAvgCost': new UntypedFormControl(),
            'retired': new UntypedFormControl(),
            'installedOn': new UntypedFormControl(),
            'cycleCountClassId': new UntypedFormControl('', Validators.required),
        });

    }
    setForm() {
        this.editForm.patchValue({
            number: this.data.number,
            inventoryId: this.data.inventoryId,
            warrantyEndDate: null,
            serialNbr: this.data.serialNbr,
            model: this.data.model,
            manufacturerNumber: this.data.manufacturerNumber,
            fullDescription: this.data.fullDescription,
            inventoryDesc: this.data.inventoryDesc,
            nonPart: this.data.nonPart,
            isCommon: this.data.isCommon,
            isActive: this.data.isActive,
            inventoryTypeId: this.data.inventoryTypeId,
            inventoryCategoryId: this.data.inventoryCategoryId,
            inventorySubCategoryId: this.data.inventorySubCategoryId,
            manufacturerId: this.data.manufacturerId,
            manufacturerTypeId: this.data.manufacturerTypeId,
            incomeAccountId: this.data.incomeAccountId,
            inventoryAccountId: this.data.inventoryAccountId,
            costAccountId: this.data.costAccountId,
            notes: this.data.notes,
            minThreshold: this.data.minThreshold,
            maxThreshold: this.data.maxThreshold,
            currentCost: this.data.currentCost,
            maxCost: this.data.maxCost,
            avgCost: this.data.avgCost,
            lastCost: this.data.lastCost,
            flatCost: this.data.flatCost,
            internationalCost: this.data.internationalCost,
            defaultPrice: this.data.defaultPrice,
            ratio: this.data.ratio,
            wgtAvgCost: this.data.wgtAvgCost,
            retired: this.data.retired,
            installedOn: this.data.installedOn,
            cycleCountClassId: this.data.cycleCountClassId,
        });

        this.loadingThings = false;
    }

    save() {
        if (!this.editForm.valid) {
            for (let i in this.editForm.controls) {
                this.editForm.controls[i].markAsTouched();
            }
            return;

        }

        this.loadingThings = true;
        let busObj: InventoryBus = new InventoryBus(this.data);
        busObj.setFromForm(this.editForm.value);
        busObj.updateDt = new Date();
        let inputParams: InventoryBusInputParams = new InventoryBusInputParams(busObj);
        inputParams.idsToBeCleared = this.idsToBeCleared;
        let dateNow: Date = new Date(Date.now());

        busObj.insertDt = dateNow;

        inputParams.inventoryThresholdOverrideBranchs = [];
        inputParams.inventoryAlternatives = [];
        inputParams.inventoryThresholdOverrides = [];

        if (this.featureFlagSet["inventory-threshold-alternatives"]) {
            if (CommonFunctions.hasValue(this.partAlternativesThresholds)) {
                inputParams.inventoryAlternatives = _.cloneDeep(this.partAlternativesThresholds.getChanged());
                inputParams.addDeletedItems(this.partAlternativesThresholds.getDeletedItems());
            }
            // let added = _.cloneDeep(this.partAlternativesThresholds.getChanged());
            // let deleted = _.cloneDeep(this.partAlternativesThresholds.getDeletedItems());
            // this.svc_data.saveInventoryAlternatives(added);
        }

        if (CommonFunctions.hasValue(this.partThresholds)) {
            inputParams.inventoryThresholdOverrides = _.cloneDeep(this.partThresholds.getChanged());
            inputParams.addDeletedItems(this.partThresholds.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.partBranchThresholds)) {
            inputParams.inventoryThresholdOverrideBranchs = _.cloneDeep(this.partBranchThresholds.getChanged());
            inputParams.addDeletedItems(this.partBranchThresholds.getDeletedItems());
        }

        if (CommonFunctions.hasValue(this.partSuppliers)) {
            inputParams.inventorySuppliers = _.cloneDeep(this.partSuppliers.getChanged());
            inputParams.addDeletedItems(this.partSuppliers.getDeletedItems());
        }

        if (CommonFunctions.hasValue(this.partInventory)) {
            inputParams.inventoryLocations = _.cloneDeep(this.partInventory.getChanged());
            inputParams.addDeletedItems(this.partInventory.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.inventoryConsumables)) {
            inputParams.inventoryConsumables = _.cloneDeep(this.inventoryConsumables.getChanged());
            inputParams.addDeletedItems(this.inventoryConsumables.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.inventoryConsMatches)) {
            inputParams.inventoryConsMatches = _.cloneDeep(this.inventoryConsMatches.getChanged());
            inputParams.addDeletedItems(this.inventoryConsMatches.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.inventoryPartNbrs)) {
            inputParams.inventoryPartNbrs = _.cloneDeep(this.inventoryPartNbrs.getChanged());
            inputParams.addDeletedItems(this.inventoryPartNbrs.getDeletedItems());
        }

        this.mainDataLoading = true;
        this.svc_data.save(inputParams).subscribe({
            next: data => {
                this.mainDataLoading = false;
                this.SaveInventorySuccess(data);
                if (this.data.isAdded && this.featureFlagService.latestFeatureFlagSet["ui-allow-direct-linking-parts"]) {
                    this.router.navigate(['/orderinginventory/Parts/', data.primaryId]);
                }
            },
            error: err => {
                this.mainDataLoading = false;
                this.CallFailed(err.message);
            }
        });
    }

    SaveInventorySuccess(data: any) {

        this.loadingThings = false;
        if (!data.saveError) {
            this.id = data.primaryId;
            this.idsToBeCleared = [];

            this.loadData(this.id);
            this.saveSuccess();
        }
        else {

            this.saveError(data.message);
        }
    }
    CallFailed(err) {
        console.error(err);
        this.loadingThings = false;
        this.saveError(err);

    }
    clear() {
        this.data = {} as InventoryBus;
        this.data.inventoryLocationXrefBuss = [];
        this.data.inventorySupplierXrefBuss = [];
        this.data.inventoryThresholdOverrides = [];
        this.data.inventoryThresholdOverrideBranchs = [];
        this.data.inventoryAlternatives = [];
        this.data.inventoryConsMatchesBuss = [];
        this.data.inventoryConsumablesBuss = [];
        this.editForm.reset();
        this.idsToBeCleared = [];
    }

    new() {
        this.clear();
        if (this.partsTabstrip) {
            this.partsTabstrip.selectTab(0);
        }

        this.data.inventoryId = '00000000-0000-0000-0000-000000000000';
        this.data.ratio = 1;
        this.data.incomeAccountId = '9794a011-5be1-4bf9-a429-c1af6861db71';
        this.data.inventoryAccountId = '7167769e-314c-455a-b4ba-82268822e6a2';
        this.data.costAccountId = 'e1c751cc-944a-450c-9922-2824014e0138';
        this.hasPhotos = false;
        this.data.inventoryPartNbrs = [];
        this.data.inventoryPhotos = [];

        this.data.isActive = true;
        this.data.isAdded = true;
        this.setForm();
        this.edit();
    }

    private determineCanEditAccounts() {

        if (this.readOnly) { return false; }

        if (this.data?.inventoryId == '00000000-0000-0000-0000-000000000000') { return true; }
        return this.rights?.EditAccountNumbers;
    }
    cancel() {

        this.data = _.cloneDeep(this.originalData);
        this.setForm();
        this.setPristine();
        this.editForm.markAsPristine();

    }
    hasPhoto: boolean = false;
    photoInfo: FileInfo[] = [];
    newPhoto() {
        this.partPhotoForm.patchValue({
            imageName: null,
            description: null,
            sequenceNumber: null,
            inventoryPhotoCategoryId: null,
            visibleToCustomers: true,

        });
        this.addPhoto = true;
        this.photoInfo = [];
        this.hasPhoto = false;
        this.partPhoto = null;
        this.partPhotoForm.markAsPristine();
        this.partPhotoForm.markAsUntouched();
        this.partPhotoForm.updateValueAndValidity();

    }
    public uploadRestrictions: FileRestrictions = {
        allowedExtensions: ['.jpg', '.png', 'jpeg', 'gif', 'JPEG']
    };
    closePhoto() {
        this.addPhoto = false;
    }
    public clearEventHandler(): void {
        this.photoInfo = [];
    }
    public refresh() {
        this.loadData(this.data.inventoryId);
    }
    mergingPart: boolean = false;
    public mergeParts() {
        this.mergingPart = true;

    }
    public closeMergingPart() {
        this.mergingPart = false;

    }

    public savePhoto() {
        if (this.photoInfo.length <= 0) {
            return;
        }
        this.loadingThings = true;
        let busObj: InventoryPhotoBus = new InventoryPhotoBus();
        busObj.setFromForm(this.partPhotoForm.value);
        busObj.inventoryId = this.data.inventoryId;
        this.svc_data.uploadInventoryPhoto(this.photoInfo, this.photoInfo[0].name, busObj).subscribe(
            data => this.inventoryPhotoSaved(data),
            err => {
                this.CallFailed(err);
            });
        this.refresh();
    }

    public deletePhoto(inventoryPhotoId: string) {
        this.loadingThings = true;
        this.svc_data.deleteInventoryPhotos(inventoryPhotoId).subscribe(
            data => this.inventoryPhotoDeleted(data),
            err => {
                console.error(err);
                this.CallFailed(err);
            });
    }
    inventoryPhotoDeleted(data: BaseMessageInfo) {
        this.loadingThings = false;
        if (!data.saveError) {
            const index = this.data.inventoryPhotos.findIndex(item => item.inventoryPhotosId === this.deleteId);

            if (index !== -1) {
                this.data.inventoryPhotos.splice(index, 1);

                if (this.data.inventoryPhotos.length === 0) {
                    this.hasPhotos = false;
                    this.photoViewer = false;
                    this.activeIndex = 0;
                    this.activeIndexDialog = 0;
                } else {
                    this.hasPhotos = true;
                    this.activeIndex = Math.min(this.activeIndex, Math.max(0, this.data.inventoryPhotos.length - 1));
                    this.activeIndexDialog = Math.min(this.activeIndexDialog, Math.max(0, this.data.inventoryPhotos.length - 1));
                }

                this.addPhoto = false;

                setTimeout(() => {
                    this.cd.detectChanges();
                    this.cd.markForCheck();
                }, 0);

                this.globals.notifySuccess("Photo deleted successfully");
            } else {
                console.warn('Photo with ID not found:', this.deleteId);
            }
        } else {
            this.saveError(data.message);
        }
    }
    deleteCurPhoto(deleteId: string) {
        this.deleteId = deleteId;
        this.cnfShow("Are you sure you want to delete this photo", CRUDActions.Delete, null, "Delete Photo", "CHSTATUS", false);

    }
    confirmDialog(data: ConfirmOutput) {
        let handled: boolean = false;
        if (data.dialogResult === CPDialogResult.ok) {

            this.deletePhoto(this.deleteId);
        }
    }

    inventoryPhotoSaved(data: BaseMessageInfo) {
        this.loadingThings = false;
        if (!data.saveError) {
            let newObj3: InventoryPhotoBus = new InventoryPhotoBus();
            newObj3.initialize(data.primaryReturn);

            if (newObj3 && newObj3.fileName) {
                if (!this.data.inventoryPhotos) {
                    this.data.inventoryPhotos = [];
                }

                this.data.inventoryPhotos.push(newObj3);

                this.addPhoto = false;
                this.activeIndex = this.data.inventoryPhotos.length - 1;
                this.hasPhotos = this.data.inventoryPhotos.length > 0;
                this.globals.notifySuccess("Photo Saved");
            } else {
                this.globals.notifyWarning("Photo saved but data may be incomplete");
            }
        } else {
            this.saveError(data.message);
        }
        this.loadingThings = false;
    }
    photoSaved(data: any) { }
    public selectEventHandler(e: FileSelectEvent): void {
        this.hasPhoto = false;
        this.photoInfo = [];
        e.files.forEach((file) => {
            if (!file.validationErrors) {
                this.photoInfo.push(file);
                const previewUrl = URL.createObjectURL(file.rawFile);
                this.partPhoto = previewUrl;

                const image = {
                    src: previewUrl,
                    uid: file.uid,
                    name: file.name
                };

                this.imagePreviews.unshift(image);
                this.hasPhoto = true;
            }
        });
        this.myFiles1 = [];
    }

    public removeEventHandler(e: RemoveEvent): void {
    }

    parentMessage(e: Message) {
        if (e.messageType === MessageType.changed) {
            this.setDirty();

        }
    }

    public expansionPanelToggle: boolean = true;
    toggleExpansion() {
        this.expansionPanelToggle == !this.expansionPanelToggle;
    }

    @ViewChild('partsTabStrip') public tabstrip: TabStripComponent;
    uiPickTab(index: number) {
        let tabIndex = this.findTabFromPassedPseudoIndex(index);
        this.tabstrip.selectTab(tabIndex);
        this.searchTarget = index + 1;
    }
    arrTabIndexTitlesByPseudoIndex: string[] = ['Part', 'Notes', 'Threshhold', 'Account Numbers', 'Consumables', 'Change History'];
    findTabFromPassedPseudoIndex(pseudoIndex: number): number {
        let tabTitle: string = this.arrTabIndexTitlesByPseudoIndex[pseudoIndex];
        for (let i = 0; i < this.tabstrip.tabs.length; i++) {
            let tabStripTab: TabStripTabComponent = this.tabstrip.tabs.toArray()[i];
            if (tabStripTab) {
                if (tabStripTab.title.includes(tabTitle)) {
                    pseudoIndex = i;
                    break;
                }
            }
        }
        return pseudoIndex;
    }

    showInfo() {
        this.info = !this.info;
    };
    anyLoadingsOn: boolean;
    setAnyLoadingsOn(): boolean {

        if (!this.featureFlagSet['flags-inventory-duplicating-part-warehouse']) {
            return false;
        }

        return this.mainDataLoading || this.addtlDataLoader;
    }
}
